<style src="./Subscribe.scss" lang="scss"></style>

<template lang="pug">
  .subscribe(
    :class='opened ? "is-opened" : null'
    v-click-outside="close"
  )
    ul.subscribe__list(
      v-show='opened'
    )
      li.subscribe__item(
        v-for='item in list'
      )
        a.subscribe__link(
          :href='item.url'
          target='_blank'
        ) 
          span.subscribe__icon(
            :style="`background-image: url(/img/soc-${item.icon}.svg)`"
          )
          span.subscribe__link-text {{ item.label }}
    button.subscribe__button(
      @click='toggle'
      type='button'
    )
      span.subscribe__button-text {{ $l10n("SUBSCRIBE") }}
      span.subscribe__arrow
        Icon(
          name='arrow'
        )
</template>

<script>
import Icon from "@/components/Icon/Icon";

export default {
  props: {
    list: { type: Array, default: () => [] }
  },
  data() {
    return {
      opened: false
    };
  },
  components: {
    Icon
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
    close() {
      this.opened = false;
    }
  }
};
</script>
